module.exports = __webpack_public_path__ + "static/media/11.f57c2874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/11.svg
// module id = 385
// module chunks = 14